import React from "react";
import TailwindPageWrapper from "../components/generic/TailwindPageWrapper";
import SponsorsPartners from "../components/sponsorDetailsPage/SponsorsPartners";

function SponsorsPartnersPage() {
  return (
    <TailwindPageWrapper>
      <div className="-mt-24 pt-24">
        <SponsorsPartners />
      </div>
    </TailwindPageWrapper>
  );
}

export default SponsorsPartnersPage;

